import { PosServiceProvider } from './../../providers/pos-service/pos-service';
import { AuthProvider } from './../../providers/auth/auth';
import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, Loading } from 'ionic-angular';
import { GlobalProvider } from '../../providers/global/global';
/**
 * Generated class for the PosCanceledPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-pos-canceled',
  templateUrl: 'pos-canceled.html',
})
export class PosCanceledPage {
  dash: {};
  loading: Loading;
  name = '';
  username = '';
  serverlocation = '';
  token = '';
  userid = '';
  totalRec = 0;
  totalAmt = 0;

  constructor(public navCtrl: NavController, public navParams: NavParams, private auth: AuthProvider,
    private posservice: PosServiceProvider, private loadingCtrl: LoadingController, private global: GlobalProvider) {
      let info = this.auth.getUserInfo();
      this.name = info.name;
      this.username = info.username;
      this.serverlocation = info.serverlocation;
      this.userid = info.userid;
      this.token = info.token;
      this.loadData();
  }
  public loadData() {
    this.showLoading();

    this.posservice.loadPOSCanceled(this.userid, this.token, this.serverlocation, this.global.ICNO)
    .then(data => {
      this.dash = data;
      this.totalAmt = this.totalamt();
      this.loading.dismiss();
    });

  }
  totalamt() {
    let total = 0;
    let m =0;
    for(let key in this.dash){
      console.log('Dash '+m+': '+this.dash[m].TotalNet);
      let j = this.dash[m].TotalNet;
      total += Number(j.replace(/,/g, ''));
      console.log('Dash Total '+m+': '+total);
      m++;
    }
    this.totalRec = m;
    return total;
  }
  showLoading() {
    this.loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    this.loading.present();
  }
  doRefresh(refresher) {
    console.log('Begin async operation', refresher);
    this.loadData();
    setTimeout(() => {
      console.log('Async operation has ended');
      refresher.complete();
    }, 2000);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad PosCanceledPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/pos-canceled/pos-canceled.ts